<header>
    <dx-toolbar
        class="header-toolbar"
        (onContentReady)="observePageMenuSlot($event)"
    >
        @if (menuToggleEnabled) {
        <dxi-item
            location="before"
            widget="dxButton"
            cssClass="menu-button"
            [options]="{
                icon: 'menu',
                stylingMode: 'text',
                onClick: toggleMenu
            }"
        >
        </dxi-item>
        } @if (title) {
        <dxi-item location="before" cssClass="header-title" [text]="title">
        </dxi-item>
        }
        <dxi-item location="before" text="v{{ packageInfo.version }}">
        </dxi-item>
        <!-- Per-page menu slot: renders whatever template the active page
             registered via HeaderContentService, and publishes its width
             there so a page can tell whether its menu fits. -->
        <dxi-item location="center" locateInMenu="never">
            <div *dxTemplate="let data of 'item'">
                @if (headerContent.content(); as pageMenu) {
                <ng-container [ngTemplateOutlet]="pageMenu"></ng-container>
                }
            </div>
        </dxi-item>
        <!-- locateInMenu never: the stretched center slot (see scss) breaks
             the toolbar's overflow measurement, which collapsed this panel
             into the overflow menu even on wide screens. Narrow screens
             instead hide the email and keep the avatar + its menu (scss). -->
        <dxi-item location="after" locateInMenu="never">
            <div *dxTemplate="let data of 'item'">
                <dx-button
                    class="user-button authorization"
                    width="210px"
                    height="100%"
                    stylingMode="text"
                >
                    <div *dxTemplate="let data of 'content'">
                        <app-user-panel
                            [menuItems]="userMenuItems"
                            menuMode="context"
                        ></app-user-panel>
                    </div>
                </dx-button>
            </div>
        </dxi-item>
    </dx-toolbar>
</header>
